// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"DK-z","carouselContainer":"EK-z"};